module.exports = __webpack_public_path__ + "img/2_82.675b1e4d.png";